/**
 * Leitura de numero digitado em campo, no teclado do tablet em pt-BR.
 *
 * Aceita virgula ou ponto como separador decimal e ignora espacos. Recusa o
 * que for ambiguo em vez de adivinhar: "1.520,5" (milhar) nao aparece numa
 * medida em cm, e interpretar errado vira uma medida 1000 vezes maior.
 *
 * Devolve `null` para campo vazio, `NaN` para texto que nao e numero e, fora
 * isso, o valor arredondado para `decimais` casas.
 */
export function lerDecimal(texto: string, decimais: number): number | null {
  const limpo = texto.replace(/\s+/g, '');
  if (limpo === '') return null;
  if (!/^-?\d+([.,]\d+)?$/.test(limpo)) return Number.NaN;
  const valor = Number(limpo.replace(',', '.'));
  const fator = 10 ** decimais;
  return Math.round(valor * fator) / fator;
}

/** Numero para o campo de digitacao: virgula decimal, sem separador de milhar. */
export function escreverDecimal(valor: number | null, decimais: number): string {
  return valor == null ? '' : valor.toFixed(decimais).replace('.', ',');
}
